
export default function Software() {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'Virus & Malware Removal',
      description: 'Complete system scan and removal of viruses, malware, spyware, and other threats to keep your computer secure.'
    },
    {
      icon: 'ri-windows-line',
      title: 'OS Installation & Upgrade',
      description: 'Fresh Windows installation and upgrades to the latest versions with proper configuration.'
    },
    {
      icon: 'ri-database-2-line',
      title: 'Data Backup & Recovery',
      description: 'Secure data backup solutions and recovery services for lost or corrupted files and documents.'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Performance Optimization',
      description: 'Speed up slow computers by removing bloatware, optimizing startup, and fine-tuning system settings.'
    },
    {
      icon: 'ri-download-cloud-line',
      title: 'Software Installation',
      description: 'Professional installation and setup of business software, productivity tools, and essential applications.'
    },
    {
      icon: 'ri-lock-password-line',
      title: 'Security Setup',
      description: 'Configure firewalls, antivirus software, and security settings to protect your system from threats.'
    }
  ];

  return (
    <section id="software" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-block px-4 py-1.5 border border-teal-600 text-teal-600 text-xs font-semibold rounded-full mb-4">
            SOFTWARE SERVICES
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Software Solutions <br className="hidden sm:block" />& Support
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            From virus removal to system optimization, we provide comprehensive software services to keep your computer running smoothly and securely
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-10 sm:mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 sm:p-8 rounded-xl hover:shadow-xl transition-all duration-300 cursor-pointer group"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-4 sm:mb-5 group-hover:bg-teal-600 transition-colors">
                <i className={`${service.icon} text-2xl text-teal-600 group-hover:text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{service.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-8 sm:p-12 text-center text-white">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
              Is Your Computer Running Slow?
            </h3>
            <p className="text-base sm:text-lg text-white/90 mb-6 sm:mb-8 leading-relaxed">
              Don&apos;t let software issues slow you down. Our expert technicians can diagnose and fix performance problems, remove malware, and optimize your system for peak performance.
            </p>
          </div>
        </div>

        <div className="mt-10 sm:mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-calendar-check-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Next-Day Service</h4>
            <p className="text-gray-600 text-sm">Most software issues resolved Next Day</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-teal-600"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">Data Protection</h4>
            <p className="text-gray-600 text-sm">Your files and personal information stay safe during service</p>
          </div>
        </div>
      </div>
    </section>
  );
}
